import _styled, { default as _styled2 } from "styled-components";
import React from "react";
import { m, useMotionValueEvent, useScroll } from "framer-motion";
import { Headline } from "~/features/ui/headline";
export type ScrollFeaturesFeatureViewProps = {
  active?: boolean;
  setActive: (i: number) => void;
  setShowMedia: (v: boolean) => void;
  index: number;
  showMedia: boolean;
  hasMedia: boolean;
  headline?: string | null;
};
export function ScrollFeaturesFeatureView(props: ScrollFeaturesFeatureViewProps) {
  const {
    active,
    index,
    setActive,
    setShowMedia,
    showMedia,
    hasMedia,
    headline
  } = props;
  const ref = React.useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start end", "end end"]
  });
  useMotionValueEvent(scrollYProgress, "change", v => {
    if (v > 0 && v < 1) {
      setActive(index);
      setShowMedia(hasMedia);
    }
  });
  const opacity = active ? 1 : showMedia ? 0 : 0.1;
  return <_StyledMDiv ref={ref} animate={{
    opacity
  }}>
      {headline && <_StyledHeadline type="h2" text={headline} />}
    </_StyledMDiv>;
}
var _StyledMDiv = _styled(m.div).withConfig({
  componentId: "sc-sf-17fmaxd-0"
})({
  "position": "relative",
  "zIndex": "10",
  "--tw-translate-y": "-50vh",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "paddingTop": "6rem",
  "paddingBottom": "6rem",
  "@media (min-width: 1024px)": {
    "paddingTop": "20rem",
    "paddingBottom": "20rem"
  }
});
var _StyledHeadline = /*#__PURE__*/_styled2(Headline).withConfig({
  displayName: "scroll-features-feature___StyledHeadline",
  componentId: "sc-1ybrzrf-0"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});